(function () {
  'use strict';

  function initNaseeboAbout(root) {
    if (!root || root.getAttribute('data-na-initialized')) return;
    root.setAttribute('data-na-initialized', 'true');

    var threadFill = root.querySelector('[data-na-thread-fill]');
    var thread = root.querySelector('[data-na-thread]');
    var progressTop = root.querySelector('[data-na-progress]');
    var chapters = root.querySelectorAll('[data-na-chapter]');
    var nodeEls = [];
    var lastActiveIndex = -1;
    var activeLabelTimeout = null;

    // All measurements below are relative to THIS section (root), never to the
    // whole document. That's what keeps the thread's height locked to the
    // section's own height and stops it from ever drifting into the footer.
    function getRootMetrics() {
      var rect = root.getBoundingClientRect();
      return {
        top: rect.top + window.scrollY,
        height: root.offsetHeight
      };
    }

    function buildNodes() {
      if (!thread) return;
      nodeEls.forEach(function (n) {
        n.node.remove();
        n.label.remove();
      });
      nodeEls = [];

      var metrics = getRootMetrics();
      chapters.forEach(function (ch) {
        var chRect = ch.getBoundingClientRect();
        var chTop = chRect.top + window.scrollY;
        var relTop = chTop - metrics.top; // px offset from the top of this section
        var pct = metrics.height > 0 ? (relTop / metrics.height) * 100 : 0;
        pct = Math.min(97, Math.max(1, pct));

        var node = document.createElement('div');
        node.className = 'na-thread-node';
        node.style.top = pct + '%';

        var label = document.createElement('div');
        label.className = 'na-thread-label';
        label.style.top = pct + '%';
        label.textContent = ch.getAttribute('data-thread-label') || '';

        thread.appendChild(node);
        thread.appendChild(label);
        nodeEls.push({ node: node, label: label, relTop: relTop });
      });
    }

    function onScroll() {
      var metrics = getRootMetrics();
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var reference = scrollTop + window.innerHeight * 0.5; // viewport midpoint as the "reading position"
      var progressPx = reference - metrics.top;
      var pct = metrics.height > 0 ? (progressPx / metrics.height) * 100 : 0;
      pct = Math.min(100, Math.max(0, pct));

      if (threadFill) threadFill.style.height = pct + '%';
      if (progressTop) progressTop.style.width = pct + '%';

      // Find the chapter the user is currently passing through: the last node
      // whose position has been scrolled past.
      var activeIndex = -1;
      nodeEls.forEach(function (n, i) {
        if (progressPx >= n.relTop) {
          n.node.classList.add('na-lit');
          activeIndex = i;
        } else {
          n.node.classList.remove('na-lit');
        }
      });

      // Flash the label of the chapter just entered, then auto-hide it after a
      // beat — next chapter repeats the same flash-then-hide when its turn comes.
      if (activeIndex !== lastActiveIndex) {
        lastActiveIndex = activeIndex;
        if (activeLabelTimeout) clearTimeout(activeLabelTimeout);

        nodeEls.forEach(function (n) {
          n.label.classList.remove('na-active');
        });

        if (activeIndex >= 0) {
          var activeNode = nodeEls[activeIndex];
          activeNode.label.classList.add('na-active');
          activeLabelTimeout = setTimeout(function () {
            activeNode.label.classList.remove('na-active');
          }, 1400);
        }
      }
    }

    var scrollScheduled = false;
    function scheduleScroll() {
      if (scrollScheduled) return;
      scrollScheduled = true;
      requestAnimationFrame(function () {
        onScroll();
        scrollScheduled = false;
      });
    }

    window.addEventListener('scroll', scheduleScroll, { passive: true });
    window.addEventListener('resize', function () {
      buildNodes();
      onScroll();
    });

    if (document.readyState === 'complete') {
      buildNodes();
      onScroll();
    } else {
      window.addEventListener('load', function () {
        buildNodes();
        onScroll();
      });
    }
    // rebuild once webfonts/images settle layout
    setTimeout(function () { buildNodes(); onScroll(); }, 800);

    // ---------- reveal + fill-text on scroll into view ----------
    var revealEls = root.querySelectorAll('.na-reveal, .na-fill-text');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('na-in');
            }
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -60px 0px' }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('na-in');
      });
    }

    // ---------- video: click to play/pause + auto-pause off-screen ----------
    var videoWraps = root.querySelectorAll('[data-na-video-wrap]');
    videoWraps.forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var toggle = wrap.querySelector('[data-na-video-toggle]');
      if (!video || !toggle) return;

      function playVideo() {
        video.play().then(function () {
          toggle.classList.add('na-playing');
        }).catch(function () {});
      }
      function pauseVideo() {
        video.pause();
        toggle.classList.remove('na-playing');
      }

      toggle.addEventListener('click', function () {
        if (video.paused) {
          playVideo();
        } else {
          pauseVideo();
        }
      });

      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) {
                pauseVideo();
              }
            });
          },
          { threshold: 0.25 }
        );
        vio.observe(wrap);
      }
    });
  }

  function boot() {
    document.querySelectorAll('.naseebo-about').forEach(initNaseeboAbout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a merchant adds this section in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.naseebo-about');
    if (root) initNaseeboAbout(root);
  });
})();